import {
  UserEntryType,
  ContentType,
  ChannelType,
  UserSessionStatus,
  SystemType,
  MessageType,
  ERROR_MESSAGE,
  UserType,
} from '@shopee/shopee-chatbot-agent-chat/dist/types';
import { DEFAULT_ENTRY_POINT } from '@shopee/shopee-chatbot-agent-chat/dist/constants';
import { InhouseConnection } from '@shopee/shopee-chatbot-agent-chat';
import { AxiosError } from 'axios';

import { InitSessionResData } from '@shopee/shopee-chatbot-agent-chat/dist/types/interface';
import { browserInstance as browser } from '@/utils/browser';
import initStore from '@/stores/init';
import sessionStore from '@/stores/session';
import agentStore from '@/stores/agent';
import userStore from '@/stores/user';
import historyStore from '@/stores/history';
import { modalStore } from '@/stores/index';
import { checkIsCouldInbound, postImg } from '@/services/chat';
import { PostMessageParams, QueueType } from '@/interfaces';
import { handleTerminalConfict } from '@/services/handleTerminalConfict';
import { CustomUploadStatus, FailedStatusNeedPrompt, MediaBroadcast, UploadStatus } from '@/types/components/Video';
import reporter from '@/utils/report';
import { AGENT_CHANNEL, ORDER_LIST_TYPE_TO_TEXT, App } from '@/config/constants';
import { getConfig, UseLiveChatSDKApp } from '@/config/core';
import { debounce } from '@/utils/lodashReplacement';
import { reportAgentMessage } from '@/utils/reportAgentMessage';
import { applyChatbotConfig } from '@/config';
import { getOfflineFormUrlWithParams } from '@/utils/getOfflineFormUrlWithParams';
import { DIALOGUE_FROM, DIALOGUE_TYPE, INHOUSE_MESSAGE_TYPE, ButtonActionType, ChasingEventType } from '@/types/common';
import { UploadEnquiryInfoBizContent, InhouseHistoryContent } from '@/types/history';
import API from '@/services';
import { handleLiveBtnClick, handleRedirectionBtnClick } from '@/utils/btnClickHandler';
import { TRACKING_PAGE } from '@/utils/tracking/constants';
import { getRandomNumbers } from '@/utils/getRandomNumbers';
import ChatMessagesArea from '@/components/ChatMessagesArea';
import { safeCallLiveChatSDK } from '@/utils/liveChatSDK';
import { FileType } from '@shopee/chatbot-ui/lib/components/BaseUpload';
import { ENTRY_POINT } from '@/types/entryPoints';
import { consumptionCSFillDatas } from '@/utils/consumptionDatas';
import getOrderSpecificLandingPage from '@/utils/experiment/getOrderSpecificLandingPage';

import { UploadFileStatus, LiveChatStatus } from './../stores/agent';
import {
  GetMsgResCode,
  extraTime,
  LIVE_LEAVE_MSG_BTN,
  LIVE_OFFLINE_FORM_PAGE,
  AGENT_END_REASON,
  FAKE_SESSION_ID,
  FIRE_FLAG,
  SEND_MESSAGE_DELAY,
  IOS_IN_USE_AGENT,
  IOS,
  addPointToVersionReg,
  getAndroidVersionReg,
  getIosVersionReg,
  isAndroidReg,
  isIosReg,
  VERSION_CONNECT,
  ReportLabel,
  DefaultQueueName,
  TRACKING_OPERATION,
  TRACKING_TARGET,
  TRACKING_SECTION,
  TRANSIFY_KEY,
  Copywriting,
  FROM,
  ChatMsgType,
} from './constants';
import { COUNTRY } from './locale';
import {
  getScreenResolution,
  getTrans,
  redirectionTo,
  handleBatchSendMessage,
  handleImageUpload,
  saveRecoveryContext,
  clearRecoveryData,
  scrollToLastUnreadMsg,
  getNewMediaUploadVersion,
  separateEnquiryType,
  handlePostEndSessionRequest,
} from './tools';
import { formatFromInUrl, getQueryForm, mktBridgeCallHandler } from './instantLoaded/toolsWithoutDeps';
import { bridgeCallFunc, getFileExtension } from './instantLoaded/tools';
import { addDialogue } from './sessionUtils';
import LIVE_HANDLER, { getHistoryForInhouseParams, getHistoryForSalesforceParams } from './liveHandler';
import { getPlatform } from './native';
import { getNetWorkInfo, NetWorkType } from './getNetWorkInfo';
import uploadMessageToSave from './uploadMessageToSave';
import { updateBubbleStatus } from './bridges/chat';
import { cancelMediaUpload, toastErrorLimit, trackImageFinish } from './videoTools';
import { getSDKToken } from './liveChatToken';
import { handlePageInactiveForPN } from './handlePageInactiveForPN';
import { dispatchTrack } from './tracking';
import { BUTTON_SELECTION } from './tracking/constants';
import { TransferType, reportTransferType } from './reportTransferType';
import { isDisableDisplayWithNewFlow } from './experiment/getLiveAgentDisplayLogic';

let connection: InhouseConnection | undefined;
interface Props {
  dialogueId: string;
  dialogueType: string;
  queueName?: string;
  channel?: number;
  userType?: number | string;
  enquiryType?: number | string;
  inboundOrderSn?: string;
  isSkipPreCheck?: boolean;
}

interface ChatMsg {
  key: string;
  params: any;
}

interface AgentListItem {
  from: 'agent' | 'system' | 'user';
  type: string;
  data?: any; // TODO:定义类型
}

interface IOrderContent {
  amount: number;
  checkout_id: number;
  image: string;
  item_count: number;
  order_id: number;
  order_list_type: number;
  order_name: string;
  order_sn: string;
  price: number;
  shop_id: number;
  specification: string;
  status: number;
  uri_key: string;
  return_id: string;
}

const addAgentSessionTimeout = (_useAfterDialogueShow_ = true) => {
  if (agentStore.inQueue) {
    return;
  }
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.SYSTEM,
    type: DIALOGUE_TYPE.SessionTimeout,
    data: {},
    _useAfterDialogueShow_,
  });
};
const addAgentSessionTransfer = (_useAfterDialogueShow_ = true) => {
  if (agentStore.inQueue) {
    return;
  }
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.SYSTEM,
    type: DIALOGUE_TYPE.SessionTransfer,
    data: { agentName: agentStore.agentName },
    _useAfterDialogueShow_,
  });
};

// agent close UI dialog
const addAgentLeave = (_useAfterDialogueShow_ = true) => {
  if (agentStore.inQueue) {
    return;
  }
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.SYSTEM,
    type: DIALOGUE_TYPE.AgentLeave,
    data: { name: agentStore.agentName },
    _useAfterDialogueShow_,
  });
};

// SF chat transfer UI dialog
const addChatTransfer = () => {
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.SYSTEM,
    type: DIALOGUE_TYPE.ChatTransfer,
    data: {},
  });
};

// session end UI dialog
export const addSessionHasEnded = () => {
  const { inAgent } = agentStore;
  inAgent
    && agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.SYSTEM,
      type: DIALOGUE_TYPE.SessionEnd,
      data: {},
    });
};

export const addUserCloseSession = () => {
  const { inAgent } = agentStore;
  inAgent
    && agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.SYSTEM,
      type: DIALOGUE_TYPE.UserCloseSession,
      data: {},
    });
};

export const endWhenError = ({ shouldClose }: { shouldClose: boolean }) => {
  agentStore.updateIsDisconnected(true);

  if (shouldClose) {
    agentStore.FINISH_LOADING_IN_AGENT();
    agentStore.END_AGENT(AGENT_END_REASON.OTHER);
    addSessionHasEnded();
    clearRecoveryData();
    // 结束会话后回到可重新进线的chatbot状态
    agentStore.END_AGENT_BY_CAN_CONTINUE();
  }
  // addSessionError();
  // agentStore.FINISH_LOADING_IN_AGENT();
  // agentStore.END_AGENT(AGENT_END_REASON.OTHER);
  // addSessionHasEnded();
  // clearRecoveryData();
};

const endWhenClose = (reason = AGENT_END_REASON.NORMAL) => {
  agentStore.END_AGENT(reason);
  // 如果没弹过rating
  if (!agentStore.hasShowRating) {
    agentStore.TOGGLE_SHOW_RATING();

    if (UseLiveChatSDKApp.is()) {
      const tokens = getSDKToken();
      const { csatParams } = getConfig();
      const queryString = Object.entries(csatParams).reduce((acc, cur) => {
        acc += `&${cur[0]}=${cur[1]}`;
        return acc;
      }, '');

      bridgeCallFunc(() => {
        // 弹出csat
        reporter.apiLog('csat popup', { level: 'debug' });
        // CSAT弹出数
        reporter.apiBatchReport({ type: 'count', value: { label: 'channel_chat_incoming_csat_popup_total' }});
        window.bridgeCallHandler('liveChatFeedbackShow', {
          show: true,
          url:
            `https://${window.location.hostname}/csat?chatKey=${agentStore.shopeeChatKey}&chatAccessToken=${tokens.chatAccessToken}&tokenSuffix=${tokens.tokenSuffix}&entry=agent`
            + queryString,
        });
      });
    } else {
      // 弹出csat
      reporter.apiLog('csat popup', { level: 'debug' });
      // CSAT弹出数
      reporter.apiBatchReport({ type: 'count', value: { label: 'channel_chat_incoming_csat_popup_total' }});
      // 弹出rating
      redirectionTo('live_chat_feedback_dialog', {
        __anim__: 3, // animation type: 3-Transparent
        chatKey: agentStore.shopeeChatKey,
        sessionId: agentStore.sessionID,
        endBy: 'agent',
      });
    }
  }
  clearRecoveryData();
  // 结束会话后回到可重新进线的chatbot状态
  agentStore.END_AGENT_BY_CAN_CONTINUE();
};

const noticeNativeWhenChatInited = async () => {
  updateBubbleStatus({ chat_status: UserSessionStatus.created, show: false });
};

export const handleCancelQueue = (endReason: string) => {
  // 取消排队
  reporter.apiLog('cancel chat', { level: 'debug' });
  // 进线取消数
  reporter.apiBatchReport({ type: 'count', value: { label: 'channel_chat_incoming_cancel_total' }});
  agentStore.QUEUE_END();
  agentStore.update_agentEndedReason(AGENT_END_REASON.USER_CANCEL_QUEUE);

  agentStore.connection?.close(
    { msg: 'USER_CANCEL_QUEUE' },
  );
};

// [live-chat-split-change]
export const pushContactUsAgainMessage = (isUseAfterDialogueShow = false, hideWebformLink = false) => {
  const options: Record<string, unknown>[] = [
    {
      content: getTrans(TRANSIFY_KEY.MESSAGE_LIVEAGENT_CHATWITHAGENT),
      onClick: () => {
        // 继续进线
        handleLiveBtnClick({
          dialogueId: '',
          dialogueType: DIALOGUE_TYPE.Live,
          text: getTrans('btn_live'),
          isHistory: false,
        });
      },
      disabledText: true,
      clickTracker: {
        page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
        trackingname: 'queueFilterNoResponse',
        data: {
          chat_id: agentStore.sessionID,
          button: 1, // 1 = chat_with_agent
        },
      },
    },
  ];
  if (!hideWebformLink) {
    options.push({
      content: getTrans(TRANSIFY_KEY.MESSAGE_LIVEAGENT_SEND_INQUIRY_TIP),
      onClick: async () => {
        const { webFormConfig } = getConfig();
        const webFormKey = webFormConfig.webFormKey || LIVE_OFFLINE_FORM_PAGE;
        // 跳转webform
        handleRedirectionBtnClick({
          text_value: '',
          text_key: '',
          uri_key: webFormKey,
          isHistory: false,
        });
      },
      clickTracker: {
        page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
        trackingname: 'queueFilterNoResponse',
        data: {
          chat_id: agentStore.sessionID,
          button: 2, // 2 = send_us_your_enquiry
        },
      },
    });
  }
  addDialogue({
    dialogueId: '',
    from: DIALOGUE_FROM.BOT,
    type: DIALOGUE_TYPE.CustomOptions,
    data: {
      type: 'vertical',
      title: getTrans(TRANSIFY_KEY.QUEUE_FILTER_SELECT_NO),
      options,
      impressionTracker: {
        page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
        trackingname: 'queueFilterNoResponse',
        data: { chat_id: agentStore.sessionID },
      },
    },
    _useAfterDialogueShow_: isUseAfterDialogueShow,
  });
};

export const queueFilterCancelQueue = () => {
  agentStore.updateShowContactMessage(true);
  // 结束排队
  handleCancelQueue('user cancel');
};

export const queueFilterContinueQueue = async () => {
  const msgId = getRandomNumbers();
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.AGENT,
    type: DIALOGUE_TYPE.Msg,
    data: {
      content: getTrans(TRANSIFY_KEY.QUEUE_FILTER_SELECT_YES),
      from: DIALOGUE_FROM.AGENT,
    },
    _useAfterDialogueShow_: true,
  });
  // 上报接口以后不需要queue filter提醒
  await (API as { cancelQueuingNotice: Function }).cancelQueuingNotice({
    session_id: agentStore.sessionKey,
    ack_type: 1,
    ack_msg: {
      session_id: agentStore.sessionKey,
      msg_type: 'TEXT',
      msg_id: msgId,
      content: JSON.stringify({ text: getTrans('btn_feedback_1') }),
      ctime: Date.now(),
    },
  });
};

const GetChatMsgFuncsNext = {
  [INHOUSE_MESSAGE_TYPE.NEW_SESSION]: () => {},
  [INHOUSE_MESSAGE_TYPE.QUEUING]: (messageItem: ContentType) => {
    const { content } = messageItem;
    const { number } = content;
    agentStore.START_AGENT();
    if (!agentStore.inQueue) {
      agentStore.QUEUE_START(); // 兼容 SF chat transfer
    }
    agentStore.UPDATE_CHAT_STATUS(LiveChatStatus.inQueue);
    agentStore.UPDATE_POSITION(number);
    !agentStore.initialPosition && agentStore.UPDATE_INITIAL_POSITION(number);
  },
  [INHOUSE_MESSAGE_TYPE.CS_JOINED]: (messageItem: ContentType) => {
    if (agentStore.inAgent && !agentStore.inQueue) {
      return;
    }
    agentStore.UPDATE_CHAT_STATUS(LiveChatStatus.inChat);
    const { content } = messageItem;
    const { cs_name: name } = content;

    const { initialPosition, queueXnumber = 0 } = agentStore;
    const is_greater_than_threshold = (initialPosition as number) > (queueXnumber as number) ? 1 : 0;

    dispatchTrack({
      operation: TRACKING_OPERATION.ACTION_LIVEAGENT_CONNECTED,
      data: {
        initial_queue_number: initialPosition,
        chat_session_id: initStore.sessionId,
        is_greater_than_threshold: is_greater_than_threshold,
      },
    });
    // 从排队切换到 CS_JOIN 才会触发
    agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.SYSTEM,
      type: DIALOGUE_TYPE.AgentEnter,
      data: { name },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
    agentStore.START_AGENT();
    agentStore.UPDATE_POSITION(0);
    agentStore.QUEUE_END();
    agentStore.UPDATE_AGENT_NAME(name);

    addMediasListener();
    addMediasEvents();
  },
  [INHOUSE_MESSAGE_TYPE.TEXT]: (messageItem: ContentType) => {
    const { content, seq_id } = messageItem;
    const { text = '' } = content;
    agentStore.NOT_TYPING();
    const from = DIALOGUE_FROM.AGENT;

    agentStore.ADD_AGENT_DATA_ITEM({
      from,
      type: DIALOGUE_TYPE.Msg,
      data: {
        content: text,
        from,
        id: agentStore.chat.channelType === ChannelType.salesforce ? seq_id + text : seq_id,
      },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.FILE]: (messageItem: ContentType) => {
    const { content, seq_id } = messageItem;
    const { size, name = '', url } = content;
    agentStore.NOT_TYPING();
    const from = 'agent';
    agentStore.ADD_AGENT_DATA_ITEM({
      from,
      type: DIALOGUE_TYPE.FileUpload,
      data: {
        title: name,
        size,
        type: getFileExtension(name),
        loading: false,
        fileUrl: url,
        id: seq_id,
      },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.IMG]: (messageItem: ContentType) => {
    const { content, seq_id } = messageItem;
    const { size, url } = content;
    agentStore.NOT_TYPING();
    const from = DIALOGUE_FROM.AGENT;
    agentStore.ADD_AGENT_DATA_ITEM({
      from,
      type: DIALOGUE_TYPE.Image,
      data: {
        imgUrl: url,
        loading: false,
        size,
        id: seq_id,
      },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.VID]: (messageItem: ContentType) => {
    const { content, seq_id } = messageItem;
    const { url, thumbnail, duration } = content;

    agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.AGENT,
      type: DIALOGUE_TYPE.Video,
      data: {
        videoUrl: url,
        videoCoverUrl: thumbnail,
        videoDuration: duration,
        status: UploadStatus.SendMessageSucceed,
        id: seq_id,
      },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.TRANSFER_SESSION]: (messageItem: ContentType) => {
    agentStore.UPDATE_AGENT_NAME(messageItem?.content?.tar_cs_name);
    addAgentSessionTransfer(messageItem._useAfterDialogueShow_);
  },
  [ChatMsgType.CHAT_TRANSFER]: () => {
    addChatTransfer();
  },
  [INHOUSE_MESSAGE_TYPE.CS_CLOSE_SESSION]: () => {},
  [INHOUSE_MESSAGE_TYPE.AGENT_TYPING]: (messageItem: ContentType) => {
    agentStore.TYPING(messageItem._useAfterDialogueShow_);
  },
  [INHOUSE_MESSAGE_TYPE.AGENT_NOT_TYPING]: () => {
    agentStore.NOT_TYPING();
  },
  [INHOUSE_MESSAGE_TYPE.ORDER]: (messageItem: ContentType) => {
    const { content = {}, seq_id } = messageItem;
    const { order_name = '', amount, status } = content as IOrderContent;
    const from = DIALOGUE_FROM.AGENT;
    agentStore.NOT_TYPING();

    agentStore.ADD_AGENT_DATA_ITEM({
      from,
      type: DIALOGUE_TYPE.Order,
      data: {
        ...content,
        title: order_name,
        item_amount: amount,
        id: seq_id,
        from,
        shouldRedirect: true,
        type_name: getTrans(ORDER_LIST_TYPE_TO_TEXT[status as keyof typeof ORDER_LIST_TYPE_TO_TEXT]) || '',
      },
      _useAfterDialogueShow_: messageItem._useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.QUEUING_CHECK_NOTICE]: (messageItem: ContentType) => {
    const { _useAfterDialogueShow_ } = messageItem as ContentType;
    agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.AGENT,
      type: DIALOGUE_TYPE.CustomOptions,
      data: {
        type: 'horizontal',
        title: getTrans(TRANSIFY_KEY.QUEUE_FILTER_MESSAGE),
        options: [
          {
            content: getTrans('btn_feedback_2'),
            onClick: queueFilterCancelQueue,
            clickTracker: {
              page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
              trackingname: 'queueFilterCard',
              data: {
                chat_id: agentStore.sessionID,
                button: 2, // 2 = no
              },
            },
            restoreClickKey: 'queueFilterCancelQueue',
          },
          {
            content: getTrans('btn_feedback_1'),
            onClick: queueFilterContinueQueue,
            clickTracker: {
              page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
              trackingname: 'queueFilterCard',
              data: {
                chat_id: agentStore.sessionID,
                button: 1, // 1 = yes
              },
            },
            restoreClickKey: 'queueFilterContinueQueue',
          },
        ],
        impressionTracker: {
          page: TRACKING_PAGE.CHANNEL_CHAT_PAGE,
          trackingname: 'queueFilterCard',
          data: { chat_id: agentStore.sessionID },
        },
      },
      _useAfterDialogueShow_,
    });
  },
  [INHOUSE_MESSAGE_TYPE.SYSTEM_NOTICE]: (messageItem: ContentType) => {
    const { _useAfterDialogueShow_, content } = messageItem as ContentType;
    const { notice_msg, buttons, variables } = content as unknown as InhouseHistoryContent;
    const commonData = {
      from: DIALOGUE_FROM.AGENT,
      type: DIALOGUE_TYPE.SystemNotice,
      data: {
        title: notice_msg,
        variables: variables,
        buttons: buttons?.map((o) => {
          return {
            buttonType: o.button_type,
            content: o.button_msg,
            variables: o.variables,
            url: o.url,
            replyMsg: o.reply_msg,
            actionType: o.action_type || ButtonActionType.None,
          };
        }),
      },
    };
    if (agentStore.inAgent) {
      agentStore.ADD_AGENT_DATA_ITEM({
        ...commonData,
        _useAfterDialogueShow_,
      });
    } else {
      addDialogue(
        [
          {
            dialogueType: DIALOGUE_TYPE.Live,
            ...commonData,
          },
        ],
        false,
      );
    }
  },
};

export const changeChasingStatus = (eventType: ChasingEventType, message: string) => {
  (API as { changeChasingStatus: Function }).changeChasingStatus({
    // TODO: 统一增加失败重试
    session_id: agentStore.sessionKey,
    event_type: eventType,
    message: { content: message, user_type: UserType.Anonymous },
  });
};

const transformIosString = (str: string) => {
  let resultVersion = str.replace(IOS_IN_USE_AGENT, IOS);
  resultVersion = resultVersion.replace(/_/g, VERSION_CONNECT);
  return resultVersion;
};

const addPointToVersion = (version: string) => {
  return version.replace(addPointToVersionReg, VERSION_CONNECT);
};

const getPhoneAndAppVersion = async () => {
  const checkVersion = await mktBridgeCallHandler('checkVersion').catch(() => {});
  const { appver } = checkVersion as any;

  const { userAgent } = navigator;

  let phoneVersion = '';

  const isIos = isIosReg.test(userAgent);
  const isAndroid = isAndroidReg.test(userAgent);

  if (isIos) {
    const match = userAgent.match(getIosVersionReg);
    phoneVersion = match ? transformIosString(match[0]) : '';
  }

  if (isAndroid) {
    const match = userAgent.match(getAndroidVersionReg);
    phoneVersion = match ? match[0] : '';
  }

  const shopeeAppVersion = `${phoneVersion}, ${addPointToVersion(String(appver))}`;

  return shopeeAppVersion;
};

const enquiryTypeMapping: {
  [propsName: string]: string;
} = {
  'Shipping & Delivery': 'Logistics',
  'Web & App Performance': 'General Feedback / Technical Issues',
  'Account & Security': 'Account & Fraud',
  Payments: 'Payments',
  'Returns & Refunds': 'Return / Refund & Order Cancellation',
  'Product Content & Legal': 'Content / Legal',
  'Vouchers & Promotions': 'Marketing & BD',
  'General Enquiries': 'General Enquiries',
  'Payments & Escrow': 'Payments',
  'Campaigns & Seller Related': 'Marketing & BD',
  'Campaigns & Seller Relate': 'Marketing & BD',
};

export function hasWebForm() {
  const { webFormConfig } = getConfig();
  // refer to getConfig
  // refer to handleRedirectionBtnClick
  // refer to REDIRECTION_URLS
  const hasWebFormMerged
    = webFormConfig.hasWebform
    && agentStore.defaultEmergencyTemplate.webFormButton;

  return hasWebFormMerged;
}


export function getWebFormKey() {
  const { webFormConfig } = getConfig();
  // refer to getConfig
  // refer to handleRedirectionBtnClick
  // refer to REDIRECTION_URLS
  const fallbackWebFormKey = webFormConfig.webFormKey || LIVE_OFFLINE_FORM_PAGE;

  return fallbackWebFormKey;

}

// session 初始化相关的异常走这里
export const addNoLiveAgenyDialog = (dialogueId: string, msgKey: string, hasWebform = false) => {
  const dialogueContent
    = hasWebform
      ? {
        dialogueId: dialogueId,
        dialogueType: '',
        from: DIALOGUE_FROM.BOT,
        type: DIALOGUE_TYPE.Redirection,
        data: {
          msgContent: getTrans(msgKey),
          buttons: [
            {
              text_key: 'chat_send_your_enquiry',
              // refer to handleRedirectionBtnClick
              // refer to REDIRECTION_URLS
              uri_key: getWebFormKey(),
              uri_extra: {},
              // webview
              extraParams: { popSelf: 1 }, // 关闭当前页面
            },
          ],
        },
      }
      : {
        from: DIALOGUE_FROM.BOT,
        type: DIALOGUE_TYPE.Msg,
        data: {
          content: getTrans(msgKey),
          from: DIALOGUE_FROM.BOT,
        },
      };

  // 关闭loadingInAgent
  agentStore.FINISH_LOADING_IN_AGENT();
  addDialogue(dialogueContent);

  uploadMessageToSave({
    dialogueId,
    messages: [
      {
        message_key: msgKey,
        is_sent_by_user: false,
      },
    ],
  });
};

// session 初始化相关的异常走这里
export const handleConnectFailure = (dialogueId: string, msgKey: string, withoutWebform?: boolean) => {
  const { webFormConfig } = getConfig();
  const dialogueContent
    = webFormConfig.hasWebform && !withoutWebform
      ? {
        dialogueId: dialogueId,
        dialogueType: '',
        from: DIALOGUE_FROM.BOT,
        type: DIALOGUE_TYPE.Redirection,
        data: {
          msgContent: getTrans(msgKey),
          buttons: [
            {
              text_key: LIVE_LEAVE_MSG_BTN,
              uri_key: webFormConfig.webFormKey || LIVE_OFFLINE_FORM_PAGE,
              uri_extra: {},
              extraParams: { popSelf: 1 }, // 关闭当前页面
            },
          ],
        },
      }
      : {
        from: DIALOGUE_FROM.BOT,
        type: DIALOGUE_TYPE.Msg,
        data: {
          content: getTrans(msgKey),
          from: DIALOGUE_FROM.BOT,
        },
      };

  // 关闭loadingInAgent
  agentStore.FINISH_LOADING_IN_AGENT();
  addDialogue(dialogueContent);

  uploadMessageToSave({
    dialogueId,
    messages: [
      {
        message_key: msgKey,
        is_sent_by_user: false,
      },
    ],
  });
};

export function updateInitMessageId(initMessageId?: string) {
  const { connectPremiumLiveChatDirectly } = agentStore;

  // 如果是直接连线的premium user，不会初始化chatbot session
  if (connectPremiumLiveChatDirectly && initMessageId) {
    historyStore.setInitMessageId(initMessageId);
    historyStore.setBeforeMessageId(initMessageId);
  }
}

export function onAgentErrorReport(error: AxiosError) {
  reporter.apiLog(error?.message);
  let label = ReportLabel.AgentError.default;
  let errorTimeType = 'init';
  if (error?.response?.data?.code === GetMsgResCode.LIVE_OFFLINE_ERROR_CODE) {
    label = ReportLabel.AgentError.Offline;
  } else if (error?.response?.data?.code === GetMsgResCode.MULTI_TERMINAL_CONFLICT) {
    label = ReportLabel.AgentError.MultiTerminalConflict;
  } else if (!agentStore.inAgent) {
    label = ReportLabel.AgentError.BeforeAgentEstablish;
  } else if (error?.response?.status !== 200) {
    label = ReportLabel.AgentError.NetworkError;
    errorTimeType = 'chat';
  } else if (error?.response?.data?.code !== 0) {
    label = ReportLabel.AgentError.DataError;
    errorTimeType = 'chat';
  }

  if (errorTimeType === 'init') {
    reporter.apiBatchReport({ type: 'count', value: { label: 'func_agent_init_exception' }});
  } else {
    reporter.apiBatchReport({
      type: 'hyper',
      value: { label: 'agent_contains_exception', value: initStore.sessionId },
    });
  }

  reporter.apiBatchReport({ type: 'count', value: { label }});
}

export function addListener(connection: InhouseConnection) {
  // 上一条消息的类型
  let lastMessageType: MessageType | undefined = undefined;
  // 未读消息数量
  let unreadMsgCount = 0;

  connection.on('init', (data: InitSessionResData) => {
    const {
      clientPollTimeout,
      id,
      key,
      shopeeChatKey,
      maxFileSize,
      maxImageSize,
      multipartUploadBlockSize,
      multipartUploadConcurrency,
      init_message_id: initMessageId,
      is_show_cancel_queue_button: isShowCancelQueueButton,
      queue_x_number: queueXnumber,
      queue_position_max: queuePositionMax,
    } = data;

    agentStore.UPDATE_CHAT_STATUS(LiveChatStatus.created);
    agentStore.SET_TIMEOUT(clientPollTimeout + extraTime);

    // 埋点——订单进线数据
    if (agentStore?.inboundOrderSn || agentStore?.isCanNotFindOrder) {
      dispatchTrack({
        operation: TRACKING_OPERATION.CLICK,
        target: TRACKING_TARGET.button,
        section: TRACKING_SECTION.inboundOrderSelection,
        data: {
          chat_id: connection.sessionId || '',
          user_type: `${agentStore?.userType}`,
          enquiry_type: `${agentStore?.enquiryType}`,
          button_selection: agentStore?.isCanNotFindOrder ? BUTTON_SELECTION.CanNotFind : BUTTON_SELECTION.Select,
          order_sn: agentStore?.inboundOrderSn || '',
        },
      });
    }

    agentStore.UPDATE_SESSION_ID(id);
    agentStore.UPDATE_SESSION_KEY(key);
    agentStore.UPDATE_CHAT_KEY(shopeeChatKey);
    agentStore.update({
      maxFileSize,
      maxImageSize,
      multipartUploadBlockSize,
      multipartUploadConcurrency,
      isShowCancelQueueButton,
      queueXnumber,
      queuePositionMax,
    });
    initMessageId && updateInitMessageId(initMessageId);
    saveRecoveryContext();
    noticeNativeWhenChatInited();
  });

  connection.on('message', (data: ContentType) => {
    handlePageInactiveForPN(data);

    if (initStore.isFromPN && data._messageType_ === MessageType.UnreadMessage) {
      data._useAfterDialogueShow_ = false;
      unreadMsgCount += 1;

      // 上一条不是未读 && 当前是未读
      if (lastMessageType !== MessageType.UnreadMessage) {
        agentStore.ADD_AGENT_DATA_ITEM({
          from: DIALOGUE_FROM.SYSTEM,
          type: DIALOGUE_TYPE.UnreadMessages,
          data: { num: data._unreadMsgCount_ },
          _useAfterDialogueShow_: false,
        });
      }

      if (unreadMsgCount === data._unreadMsgCount_) {
        unreadMsgCount = 0;
        lastMessageType = undefined;

        scrollToLastUnreadMsg();
      }
    }

    lastMessageType = data._messageType_ ?? MessageType.RealTimeMessage;

    GetChatMsgFuncsNext[data.msg_type as keyof typeof GetChatMsgFuncsNext]?.(data);
    data.seq_id && agentStore.UPDATE_SEQ(data.seq_id);
    data.chatbot_message_id && reportAgentMessage(data.chatbot_message_id);
    if (UseLiveChatSDKApp.is()) {
      data.chatbot_message_id
        ? historyStore.updateHasShownLiveChatMsgIds(data.chatbot_message_id)
        : data.seq_id && historyStore.updateHasShownLiveChatMsgSeqIds(String(data.seq_id));
    }
    agentStore.updateIsDisconnected(false);
  });

  connection.on(
    'close',
    (data: {
      msg: string;
      _messageType_: MessageType;
      _unreadMsgCount_: number;
      chatbot_message_id: string;
      seq_id: string;
      data: any;
    }) => {
      handlePageInactiveForPN(data);
      const { msg = '', _messageType_, _unreadMsgCount_, chatbot_message_id, seq_id } = data;
      const bizContent = JSON.parse(data?.data?.biz_content || '{}');
      const closeType = JSON.parse(bizContent?.content || '{}')?.type;
      console.log('close', msg);

      if (UseLiveChatSDKApp.is()) {
        chatbot_message_id
          ? historyStore.updateHasShownLiveChatMsgIds(chatbot_message_id)
          : seq_id && historyStore.updateHasShownLiveChatMsgSeqIds(seq_id);
      }

      // liveChatSDKApp.isInUsing() && chatbot_message_id && historyStore.updateHasShownLiveChatMsgIds(chatbot_message_id);

      let _useAfterDialogueShow_ = true;

      if (initStore.isFromPN && _messageType_ === MessageType.UnreadMessage) {
        _useAfterDialogueShow_ = false;
        unreadMsgCount += 1;

        if (unreadMsgCount === _unreadMsgCount_) {
          unreadMsgCount = 0;
          lastMessageType = undefined;

          scrollToLastUnreadMsg();
        }
      }

      chatbot_message_id && reportAgentMessage(chatbot_message_id);

      if (msg === 'SESSION_CLOSE_TIMEOUT') {
        // 会话超时不提供评价
        agentStore.TOGGLE_SHOW_RATING();
        addAgentSessionTimeout(_useAfterDialogueShow_);
        endWhenClose(AGENT_END_REASON.TIMEOUT);
        return;
      }

      if (msg === 'SESSION_CLOSED') {
        addSessionHasEnded();
        agentStore.END_AGENT(AGENT_END_REASON.OTHER);
        // closeType为5代表是排队过滤多次未点击超时结束，这两种情况都需要推送重连消息
        if (Number(closeType) === 5) {
          agentStore.END_AGENT_BY_QUEUE_FILTER_TIMEOUT();
          agentStore.updateShowContactMessage(false);
          setTimeout(() => {
            pushContactUsAgainMessage(true);
          }, 100);
        }
        return;
      }

      // overflow management 用户主动在queue时结束会话
      if (agentStore.agentEndedReason === AGENT_END_REASON.USER_CANCEL_QUEUE) {
        addSessionHasEnded();
        clearRecoveryData();
        agentStore.END_AGENT_BY_CANCEL_QUEUE();
        // showContactMessage为点击排队过滤的no选项派发重连消息;
        if (agentStore.showContactMessage) {
          agentStore.updateShowContactMessage(false);
          setTimeout(() => {
            pushContactUsAgainMessage(true);
          }, 100);
        }
        return;
      }

      if (msg === 'USER_CLOSED') {
        addUserCloseSession();
      } else {
        addAgentLeave(_useAfterDialogueShow_);
      }
      endWhenClose();
    },
  );
  connection.on('error', (error: AxiosError, { shouldClose }: { shouldClose: boolean }) => {
    console.error(error, shouldClose);

    onAgentErrorReport(error);

    if (error?.response?.data?.code === GetMsgResCode.LIVE_OFFLINE_ERROR_CODE) {
      // no valid agent时,增加配置化的reason和webform是否隐藏
      const { reason, hidden_webform_link } = error?.response?.data?.data || {};
      const { webFormButton } = agentStore.defaultEmergencyTemplate;

      const initMessageId = error?.response?.data?.data?.init_message_id || '';
      let { liveAgentOfflineText: LIVE_AGENT_OFFLINE_TEXT } = getConfig();
      if (reason) {
        LIVE_AGENT_OFFLINE_TEXT = reason;
      }
      updateInitMessageId(initMessageId);
      agentStore.QUEUE_END();
      agentStore.UPDATE_INIT_SESSION_ERROR(true);
      // 没有客服,返回离线表格
      const hideWebformLink = typeof hidden_webform_link === 'boolean' ? hidden_webform_link || !webFormButton : false;

      handleConnectFailure(connection.chatbot_dialogue_id || '', LIVE_AGENT_OFFLINE_TEXT, hideWebformLink);
    } else if (error?.response?.data?.code === GetMsgResCode.MULTI_TERMINAL_CONFLICT) {
      handleTerminalConfict();
    } else if (!agentStore.inAgent) {
      agentStore.UPDATE_INIT_SESSION_ERROR(true);
      // 还未进入排队状态就出现异常
      addEmergencyTemplateRemind('(0001)');
      // 将会话状态重置为none，避免下次进来页面恢复会话
      agentStore.UPDATE_CHAT_STATUS(LiveChatStatus.none);
      return;
    } else if (error?.response?.status !== 200) {
      // 通用处理
      // init_chat 接口报错不提示
      const remindError = error?.config?.url === '/init_chat' ? false : true;
      remindError && addEmergencyTemplateRemind(error?.response?.status ? `(${error?.response?.status})` : '');
      if (!remindError) {
        return;
      }
    } else if (error?.response?.data?.code !== 0) {
      addEmergencyTemplateRemind(error?.response?.data?.code ? `(${error?.response?.data?.code})` : '');
    }
    endWhenError({ shouldClose });
  });

  connection.on('config', (data) => {
    agentStore.updateConnectionConfigInfo(data);
  });
}

export const joinChat = async (props: Props) => {
  // 用户开始进入live Chat连接流程
  // 只要客服试图连接客服，就更新ONCE_IN_QUEUE
  agentStore.UPDATE_ONCE_IN_QUEUE();
  reporter.apiLog('live Chat incoming', { level: 'debug' });
  const { dialogueId, dialogueType, queueName, isSkipPreCheck } = props;

  // 先确保 channelType 存在
  if (agentStore.chat?.channelType === undefined) {
    await agentStore.chat.getChannelType();
  }

  // 没有配置 userType值：inhouse时传 0；salesforce 传空字符串
  if (agentStore.chat?.channelType === ChannelType.inhouse) {
    agentStore.userType = agentStore.userType || 0; // 默认（兜底）与premium user都是0
    agentStore.enquiryType = agentStore.enquiryType || 0;
  }

  const { userName, userId, phone, email, loyaltyTierCode, isLogin, avatar, loyaltyTierName, account_type } = userStore;
  const { from, sessionId: chatbotSessionId, isPremiumUser, searchUrl, isPremium } = initStore;
  const enquiryType = queueName || agentStore.enquiryType;
  // SF 下 userType 是从 queue name 中获取的, inhouse 从 store 中获取
  const [userType, queue_name] = separateEnquiryType(enquiryType);
  const formatEnquiryType = enquiryTypeMapping[queue_name] || queue_name;
  const chatbotTask = sessionStore.activatedDialogueType.join(',');
  const chatbotArticle = sessionStore.showedArticleList.join(',');
  // driver 从url中获取ordersn
  const orderSN = sessionStore.newOrderSNList.length ? sessionStore.newOrderSNList.join(',') : (getQueryForm('ordersn', searchUrl) || sessionStore.orderSNList.join(','));
  const returnSN = sessionStore.orderInfo.returnSN ? String(sessionStore.orderInfo.returnSN) : '';
  const returnID = sessionStore.orderInfo.returnID ? String(sessionStore.orderInfo.returnID) : '';
  const screenResolution = getScreenResolution();
  const shopeeAppVersion = await getPhoneAndAppVersion();
  const { networkType } = await getNetWorkInfo();
  let csFillDatas = await consumptionCSFillDatas(); // 如果有csFillToken参数的话，会通过token拿到存储的数据放到进线参数里
  const isApp = browser.shopeeAppOrLiveChat;
  const subject = isPremiumUser ? `Chat with Platinum user ${userName}` : `Chat with ${userName}`;
  const { userAgent } = navigator;
  const isIos = isIosReg.test(userAgent);
  const isAndroid = isAndroidReg.test(userAgent);
  const defaultChannel = isPremium ? AGENT_CHANNEL.PREMIUM : AGENT_CHANNEL.Normal;
  const appEntryPoint = transformFrom();
  const entry_point = agentStore?.autoQueueEntryPoint ?? (formatFromInUrl(appEntryPoint) as ENTRY_POINT);

  reporter.apiBatchReport({ type: 'count', value: { label: ReportLabel.Agent.start }});

  const params: UploadEnquiryInfoBizContent = {
    message: getHistoryForInhouseParams(),
    queue_name: props.queueName,
    inbound_order_sn: agentStore?.inboundOrderSn,
    channel: props.channel || defaultChannel,
    chatbot_session_id: chatbotSessionId === FAKE_SESSION_ID ? '' : chatbotSessionId,
    chatbot_dialogue_id: dialogueId,
    user_entry_type: isApp ? UserEntryType.APP : UserEntryType.PC,
    user_id: userId || 0,
    // 这个 entry point 是 Inhouse 用的
    entry_point: entry_point || DEFAULT_ENTRY_POINT,
    // 这个 entry point 是 SF 用的
    app_entry_point: appEntryPoint,
    // Salesforce 的 user_type 是 string, Inhouse 的是枚举
    user_type: userType,
    // Salesforce 的 enquiry_type 是 string, Inhouse 的是枚举
    enquiry_type: formatEnquiryType,
    chat_entry: dialogueType,
    user_name: userName,
    requester_phone: phone,
    requester_email: email,
    order_sn: orderSN,
    return_sn: returnSN,
    return_id: returnID,
    shopee_app_version: shopeeAppVersion,
    last_article_url: 'chatBot',
    last_article_id: initStore.lastArticleID,
    chatbot_article: chatbotArticle,
    chatbot_taskbot: chatbotTask,
    // SDK 目前还有其他需求的代码, 先让业务代码来兼容 customer_loyalty_tier 的类型.
    // 之后直接升级 SDK 版本且把 toString 去掉即可
    // @ts-ignore
    customer_loyalty_tier: loyaltyTierCode.toString(),
    shipping_id: '',
    network: NetWorkType[networkType],
    platform: getPlatform(),
    screen_resolution: screenResolution,
    visitor_ip_address: '',
    region: COUNTRY.toLocaleUpperCase('en-US'),
    contact_type: 'Chat',
    subject: subject,
    chatbotSessionId: chatbotSessionId === FAKE_SESSION_ID ? '' : chatbotSessionId,
    chatbotHistory: getHistoryForSalesforceParams(),
    entry_from_label: from === ENTRY_POINT[ENTRY_POINT.shippingPage] ? '' : from,
    // @ts-ignore
    userTypeName: agentStore.userTypeName,
    inhouseEnquiryTypeName: agentStore.inhouseEnquiryTypeName,
    problem_type_id: agentStore.problemType,
    description: agentStore.description,
    attachments: agentStore.files?.map?.(file => ({
      ...file,
      type: {
        [FileType.File]: 'FILE',
        [FileType.Image]: 'IMG',
        [FileType.Video]: 'VID',
      }[file.type],
    } as any)),
    startSessionParams: { is_continue_for_exceed_queue_limit: isSkipPreCheck },
  };

  csFillDatas = {
    ...csFillDatas,
    user_type_label: agentStore.userTypeLabel,
    selected_case: {
      user_exist_case: agentStore.userExistCase,
      case_id: agentStore.caseId,
      first_enquiry_time: agentStore.firstEnquiryTime,
      case_update_time: agentStore.caseUpdateTime,
      reason_code: agentStore.reasonCode,
      order_sn: agentStore.orderSN,
      order_item_name: agentStore.orderItemName,
      order_item_first_image_url: agentStore.orderItemFirstImageUrl,
    },
  };

  // 如果csFillDatas存在数据的话就设置到参数里
  if (Object.keys(csFillDatas || {}).length > 0) {
    params.csFillDatas = csFillDatas;
  }

  const { app } = getConfig();

  if (app === App.Driver) {
    params.driver_order_id = orderSN;
  }

  if (isApp && (isIos || isAndroid)) {
    const appInfo = {
      [App.Shopee]: () => ({
        type: isIos ? SystemType.ShopeeIos : SystemType.ShopeeAndroid,
        version: window.getAppVersion()?.toString(),
      }),
      [App.Driver]: () => ({
        type: isIos ? SystemType.DriverIos : SystemType.DriverAndroid,
        version: window.getHostAppVersion?.()?.toString() || '',
      }),
      [App.Bank]: () => ({
        type: isIos ? SystemType.BankIos : SystemType.BankAndroid,
        version: window.getHostAppVersion?.()?.toString() || '',
      }),
      [App.Mitra]: () => undefined,
      [App.Partner]: () => undefined,
      [App.Food]: () => undefined,
      [App.ShopeeLite]: () => ({
        type: isIos ? SystemType.ShopeeIos : SystemType.ShopeeAndroid,
        version: window.getAppVersion()?.toString(),
      }),
    };
    params.app_info = appInfo[app]();
  }
  // 每次进线前将contact message标记设置为false
  agentStore.updateShowContactMessage(false);

  handlePostEndSessionRequest();

  // [live-chat-split-change]
  // connection = await agentStore.initConnection(params);
  safeCallLiveChatSDK((sdk) => {
    // @ts-ignore
    sdk?.init?.(
      document.getElementById('app'),
      {
        liveChatInfo: params,
        chatbotInfo: {
          sessionInfo: {
            sessionId: params.chatbot_session_id,
            sessionToken: initStore.sessionToken,
            chatbotAvatar: initStore.botAvatar,
            sellerLiveAgentAvatar: initStore.agentAvatar,
            floattingBubbleQueueAvatar: initStore.queueAvatar,
            floattingBubbleChattingAvatar: initStore.chattingAvatar,
          },
        },
        authInfo: {
          userId,
          userName,
          phone,
          email,
          avatar,
          loyaltyTierCode,
          loyaltyTierName,
          accountType: account_type,
        },
        isLogined: isLogin,
      },
      { historyDom: ChatMessagesArea },
      {
        getToken: getSDKToken,
        sendBotMessage: addDialogue,
      },
    );
  });
};

/** 批量发消息，由于接口限频，所以在发消息时添加延迟 */
export const batchPostChatMsg = (() => {
  // 存储还没有发送的消息
  const chatMsgToPost: ChatMsg[] = [];
  const extraParams: Array<any> = [];
  const callbacks: Array<any> = [];
  // 是否正在发送消息
  let isSending = false;

  return (
    key: string,
    params: any,
    extra?: any,
    callback?: (response: { code: number; data?: any }, _extraParams: any) => void,
  ) => {
    chatMsgToPost.push({ key, params });
    extraParams.push(extra);
    callbacks.push(callback);

    agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADING);

    // 遍历未发送消息 延迟发送
    const loop = async () => {
      isSending = true;

      await sleep(SEND_MESSAGE_DELAY);

      const chatMsg = chatMsgToPost.shift() as ChatMsg;
      const getExtraParams = extraParams.shift();
      const cb = callbacks.shift();

      if (chatMsg) {
        const { params: p } = chatMsg;
        postChatMsg(p)
          .then((res) => {
            agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADED);

            if (cb) {
              cb(res, getExtraParams);
            }
          })
          .then(() => loop())
          .catch(() => loop());
      }

      isSending = false;
    };

    if (!isSending) {
      loop();
    }
  };
})();

export const sleep = (millseconds: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, millseconds);
  });
};

// 发送消息
export const postChatMsg = async (data: PostMessageParams, time = 0) => {
  const connection = agentStore.connection;
  const chat = agentStore.chat;
  await agentStore.restorePromise;

  if (!connection) {
    return -1;
  }

  // 向 agent 发送消息
  reporter.apiBatchReport({ type: 'count', value: { label: 'func_agent_msg' }});
  const { type, text, params } = data;
  const getInhouseMsgType = (type?: 'file' | 'TEXT' | 'FILE' | 'IMG' | 'VID' | 'ORDER') => {
    if (!type) {
      return 'TEXT';
    }
    const map: {
      [propsName: string]: 'TEXT' | 'FILE' | 'IMG' | 'VID' | 'ORDER';
    } = {
      file: 'FILE',
      TEXT: 'TEXT',
      FILE: 'FILE',
      IMG: 'IMG',
      VID: 'VID',
      ORDER: 'ORDER',
    };
    return map[type];
  };
  const msgType = getInhouseMsgType(type);

  const res = await connection.sendMessage({
    msg_type: msgType,
    content: {
      text,
      ...params,
    },
  });

  if (res instanceof Error) {
    if (res.message === ERROR_MESSAGE.RESEND_MESSAGE) {
      if (++time <= 2) {
        // 重试时不返回失败错误码给
        const res: any = await postChatMsg(data, time);
        return res;
      }
    }
    console.error(res);
    const code = (res as AxiosError)?.response?.data?.code;

    handlePostChatMsgError(msgType, res);

    switch (code) {
      case GetMsgResCode.ILLEGAL: // 403 不合法，终止
      case GetMsgResCode.SESSION_EXPIRED: // 40001 session已过期
        addEmergencyTemplateRemind(`(${code})`);
        addSessionHasEnded();
        agentStore.END_AGENT(AGENT_END_REASON.OTHER);
        return { code };
      case GetMsgResCode.SEND_FAIL: // 60002 发送失败，重试2次
        if (++time <= 2) {
          // 重试时不返回失败错误码给
          const res: any = await postChatMsg(data, time);
          return res;
        } else {
          addEmergencyTemplateRemind(`(${code})`);
          if (agentStore.agentEndedReason === AGENT_END_REASON.TIMEOUT) {
            addAgentSessionTimeout();
          } else {
            addSessionHasEnded();
          }

          agentStore.END_AGENT(AGENT_END_REASON.OTHER);
          return { code };
        }
      default:
        // 其他错误
        return { code };
    }
  }

  const { code, data: resData } = res;

  if (code === GetMsgResCode.SUCCESS) {
    if (UseLiveChatSDKApp.is()) {
      const chatbotMessageId = resData?.chatbot_message_id || resData?.message_id;
      chatbotMessageId
        ? historyStore.updateHasShownLiveChatMsgIds(`${chatbotMessageId}`)
        : resData.seq_id && historyStore.updateHasShownLiveChatMsgSeqIds(resData.seq_id);
    }
    // 向 agent 发送消息成功
    reporter.apiBatchReport({ type: 'count', value: { label: 'func_agent_msg_ok' }});
  }

  handlePostChatMsgSucceed(msgType, res);
  return res;
};

export const handlePostChatMsgError = (type: string, res?: Error) => {
  try {
    reporter.apiLog('send_message send_message_error', { level: 'error', res: JSON.stringify(res) });
  } catch {}

  switch (type) {
    case 'IMG':
      trackImageFinish({
        isUploadSuccess: true,
        isSendSuccess: false,
      });
      return;
    default:
      return;
  }
};

export const handlePostChatMsgSucceed = (type: string, data: any) => {
  switch (type) {
    case 'IMG':
      trackImageFinish({
        isUploadSuccess: true,
        isSendSuccess: true,
        messageId: data?.data?.message_id || '',
      });
      return;
    default:
      return;
  }
};

export const postChatImg = async (file: File, curPos: number, needSendMsg: boolean) => {
  const postImgRes = await postImg(file).catch(() => {});

  if (postImgRes) {
    const imageUrl = postImgRes.url;

    if (needSendMsg) {
      // 正在发送消息
      agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADING);
      // 上传成功，直接发送图片链接
      postChatMsg({
        type: 'IMG',
        text: imageUrl,
        params: {
          thumbnail: imageUrl,
          url: imageUrl,
        },
      }).then(({ code }) => {
        if (code === GetMsgResCode.SUCCESS) {
          agentStore.UPDATE_AGENT_DATA_ITEM(
            {
              imgUrl: imageUrl,
              image: null,
            },
            curPos,
          );
        }

        agentStore.UPDATE_FILE_UPLOADING_COUNT(UploadFileStatus.UPLOADED);
        agentStore.UPDATE_AGENT_DATA_ITEM(
          {
            sendMsgError: code !== GetMsgResCode.SUCCESS,
            _imgUrl: imageUrl, // 用来缓存，在消息发送失败时使用
            loading: false,
          },
          curPos,
        );
      });
    }
    return imageUrl;
  } else {
    // 上传图片失败
    return false;
  }
};

// 处理请求getChatHistory结束后续工作
// 获取浮窗部分收到的增量已读消息
export const getChatHistoryReqFn = async (
  key: string = agentStore.sessionKey,
  sequence: number,
  unreadMsgs: number,
) => {
  // 开启isLoadingHistory
  // agentStore.TOGGLE_LOADING_HISTORY(true);
  agentStore.UPDATE_FIRE_STORE({ flag: FIRE_FLAG.IS_REQUESTING });
  const { shopeeChatKey, sessionID, sessionKey, timeout, userType, channelType } = agentStore;
  connection = await agentStore.restoreConnection({
    id: sessionID,
    key: sessionKey,
    shopeeChatKey,
    sequence,
    timeout,
    userType,
    channelType,
  });
  if (!connection) {
    return;
  }

  const images = agentStore.fireStore?.images || [];

  agentStore.UPDATE_FIRE_STORE({ flag: FIRE_FLAG.FINISH, images: [] });

  if (images.length) {
    // 为了保证客服收到的图片顺序与用户端展示的顺序一致
    Promise.all(
      images.map((image: any) => {
        return new Promise((resolve) => {
          handleImageUpload(image.image, image.curPos).then(resolve).catch(resolve);
        });
      }),
    ).then((messages) => {
      handleBatchSendMessage(messages);
    });
  }

  // 回显未读消息数量
  unreadMsgs
    && agentStore.ADD_AGENT_DATA_ITEM({
      from: DIALOGUE_FROM.SYSTEM,
      type: DIALOGUE_TYPE.UnreadMessages,
      data: { num: unreadMsgs },
    });
};

export const getChatHistoryReq = debounce(getChatHistoryReqFn, 500);

// 发消息前校验 agent 状态
export const reviewChatEndText = () => {
  if (agentStore.agentEndedReason === AGENT_END_REASON.NORMAL) {
    addAgentLeave();
  } else if (agentStore.agentEndedReason === AGENT_END_REASON.OTHER) {
    addSessionHasEnded();
  }
};

export const addAgentTip = (content: string) => {
  agentStore.ADD_AGENT_DATA_ITEM({
    from: DIALOGUE_FROM.SYSTEM,
    type: DIALOGUE_TYPE.Tip,
    data: { content },
  });
};

export const addUserMsg = (dataItem: any, withTyping = true, targetSessionId?: string) => {
  if (Array.isArray(dataItem)) {
    dataItem.forEach((item) => addUserMsg(item, withTyping, targetSessionId));
  } else {
    // 用户输入：频控
    if (dataItem.from === 'user' && withTyping) {
      // 过快
      if (agentStore.ifRequestOverfast) {
        // 提示输入过快
        addAgentTip(getTrans('agent_error_too_frequent'));
        // 调用方判断为false说明不该进行下一步动作
        return false;
      } else {
        agentStore.UPDATE_REQUEST_TIMESTAMP();
        return agentStore.ADD_AGENT_DATA_ITEM(dataItem, targetSessionId);
      }
    } else {
      return agentStore.ADD_AGENT_DATA_ITEM(dataItem, targetSessionId);
    }
  }
};

export async function startAgent(
  dialogueId: string,
  queueName: number | string = '',
  dialogueType?: string,
  extraParams?: Record<string, any>,
) {

  if (isDisableDisplayWithNewFlow() && agentStore.inNewFlowBeforeAgent) {
    agentStore.UPDATE_IN_BEFORE_AGENT(false);
  }

  // 存传参供重新进线使用
  modalStore.UPDATE_START_AGENT_PARMAS({ dialogueId, queueName, dialogueType, extraParams });

  if (agentStore.loadingInAgent || agentStore.inAgent) {
    return;
  }

  // 获取userType(SF 下 userType 是从 queue name 中获取的, inhouse 从 store 中获取)
  const enquiryType = queueName || agentStore.enquiryType;
  const [userType, queue_name] = separateEnquiryType(enquiryType);

  // 获取enquiryType
  const formatEnquiryType = enquiryTypeMapping[queue_name] || queue_name;

  // 获取entryPoint
  const appEntryPoint = transformFrom();
  const entryPoint = agentStore?.autoQueueEntryPoint ?? (formatFromInUrl(appEntryPoint) as ENTRY_POINT);
  const reasonCode = agentStore?.reasonCodeL1Id;
  // 判断是否被熔断
  let isCouldInboundRes: any = { is_could_inbound: true };
  if (!extraParams?.isSkipPreCheck) {
    try {
      isCouldInboundRes = (
        await checkIsCouldInbound({
          entry_point: entryPoint,
          enquiry_type: Number(formatEnquiryType),
          user_type: Number(userType),
          reason_code: Number(reasonCode),
        })
      )?.data || { is_could_inbound: true };
    } catch (error) {
      isCouldInboundRes.is_could_inbound = true;
    }
  }

  if (!isCouldInboundRes?.is_could_inbound) {
    // 发送 SystemNotice 消息
    const { notice_msg, buttons, variables } = isCouldInboundRes?.check_intercept_notice || {};
    addDialogue({
      from: DIALOGUE_FROM.AGENT,
      type: DIALOGUE_TYPE.SystemNotice,
      data: {
        title: notice_msg,
        variables: variables,
        buttons: buttons?.map((o: any) => {
          return {
            buttonType: o.button_type,
            content: o.button_msg,
            variables: o.variables,
            url: o.url,
            replyMsg: o.reply_msg,
            actionType: o.action_type || ButtonActionType.None,
          };
        }),
      },
    });
  } else {
    // 直接进入客服
    // 让所有live按钮消失
    agentStore.LOADING_IN_AGENT();
    // 连入客服
    LIVE_HANDLER({
      dialogueId,
      dialogueType,
      queueName,
      ...(extraParams || {}),
    });
  }

  reportTransferType({ sessionId: initStore.sessionId, transferType: TransferType.ToLiveAgent });
}

export const premiumUserConnect = () => {
  const { from } = initStore;

  // 白金用户设置 默认值
  agentStore.UPDATE_AGENT_CASE_FIELD();

  agentStore.LOADING_IN_AGENT();
  userStore.execWhenLoaded(() => {
    LIVE_HANDLER({
      dialogueType: from.replace('Premium', ''),
      channel: AGENT_CHANNEL.PREMIUM,
    });
  });
};

export const shopeeFoodConnect = () => {
  agentStore.LOADING_IN_AGENT();
  userStore.execWhenLoaded(() => {
    LIVE_HANDLER({
      dialogueType: initStore.from,
      channel: AGENT_CHANNEL.Normal,
      queueName: DefaultQueueName.ShopeeFood,
    });
  });
};

export async function goDirectlyToAgent({ listPos }: { listPos?: number } = {}) {
  // 如果入口是 shopeeFoodHC
  if (initStore.from === FROM.ShopeeFoodHC) {
    const channelType = await agentStore.chat.getChannelType();
    if (channelType === ChannelType.salesforce) {
      shopeeFoodConnect();
      return true;
    }
  }

  return false;
}

export const addMediasListener = () => {
  bridgeCallFunc(() => {
    window.bridgeCallHandler('mediaStartListeningForUploadProgress', null, function () {});
  });
};

export const addMediasEvents = () => {
  window.bridgeRegisterHandler('MEDIA_SELECT_UPLOAD_PROGRESS_EVENT', function (mediaBroadcast: MediaBroadcast) {
    const { id, ...restMediaInfo } = mediaBroadcast;
    updateMediaInfo({ ...restMediaInfo, vid: id }, true);
  });
};

export const updateAllMediasInfo = () => {
  // 更新所有存储的medias状态
  // 在页面 reappear 时候 而且正在和客服聊天时 调用
  if (!agentStore.agentEndedReason) {
    Object.keys(agentStore.mediasIdMapPosition).map((vid) => {
      getMediaStatusWithIdAndUpdate(vid);
    });
  }
};

export const getMediaStatusWithIdAndUpdate = (id: string) => {
  bridgeCallFunc(() => {
    window.bridgeCallHandler(
      'mediaGetStatusWithId',
      { id },
      function ({ error, data }: { error: number; data: MediaBroadcast }) {
        if (error === 0) {
          updateMediaInfo({ ...data, vid: id }, false);
        }
      },
    );
  });
};

export const updateMediaInfo = (newMediaInfo: Omit<MediaBroadcast, 'id'>, showToast?: boolean) => {
  const { vid, status: newStatus } = newMediaInfo; // newStatus 为收到的新状态
  const curPos = agentStore.mediasIdMapPosition[vid];
  const { data: { status }} = agentStore.GET_AGENT_DATA_ITEM(curPos); // status 为当前的旧状态

  // 如果当前状态 不是自定义状态
  // 则继续处理 收到的广播值
  if (!CustomUploadStatus.includes(status) && ![UploadStatus.UploadCanceled].includes(status)) {
    agentStore.UPDATE_AGENT_DATA_ITEM({ ...newMediaInfo }, curPos);
  }

  // 如果当前状态 需要弹出toast 提示
  // 限制弹出频率
  if (FailedStatusNeedPrompt.includes(newStatus) && showToast) {
    toastErrorLimit();
  }
};

export const removeMediasListener = () => {
  bridgeCallFunc(() => {
    window.bridgeCallHandler('mediaStopListeningForUploadProgress', null, function () {});
  });
};

// 回话结束后 修改上传中的状态为取消上传
export const updateMediasStatusWhenChatEnd = (showToast: boolean) => {
  const { mediasIdMapPosition } = agentStore;

  Object.entries(mediasIdMapPosition).map(([vid, curPos]: [string, any]) => {
    const { data } = agentStore.GET_AGENT_DATA_ITEM(curPos);

    if (data.status !== UploadStatus.SendMessageSucceed) {
      cancelMediaUpload([vid]);
      updateMediaInfo({ ...data, vid, status: UploadStatus.UploadCanceled }, showToast);
    }
  });
};

export const enableIosBlankDetection = (enabled: boolean) => {
  const { userAgent } = navigator;
  const isIos = isIosReg.test(userAgent);
  const appVersion = window.getAppVersion();

  if (isIos && appVersion >= getNewMediaUploadVersion()) {
    bridgeCallFunc(() => {
      ['enableRefreshOnWebViewBlankWhenViewDidAppear', 'enableRefreshOnWebViewBlankWhenProcessTerminated'].map(
        (bridgeName) => {
          window.bridgeCallHandler(bridgeName, { enabled });
        },
      );
    });
  }
};

export const addEmergencyTemplateRemind = (extra = ''): void => {
  const { content, webFormButton } = agentStore.defaultEmergencyTemplate;
  const from = agentStore.inAgent ? DIALOGUE_FROM.AGENT : DIALOGUE_FROM.BOT;
  const { webFormConfig: { webFormKey }} = getConfig();

  const data: AgentListItem | any = webFormButton
    ? {
      from,
      type: DIALOGUE_TYPE.Redirection,
      data: {
        msgContent: content,
        buttons: [
          {
            text_key: LIVE_LEAVE_MSG_BTN,
            uri_key: webFormKey || LIVE_OFFLINE_FORM_PAGE,
            uri_extra: {},
            extraParams: { popSelf: 1 }, // 关闭当前页面
          },
        ],
      },
    }
    : {
      from,
      type: DIALOGUE_TYPE.Msg,
      data: {
        content: content,
        from,
      },
    };

  if (!agentStore.inAgent) {
    agentStore.FINISH_LOADING_IN_AGENT();
  }

  agentStore.inAgent ? agentStore.ADD_AGENT_DATA_ITEM(data) : addDialogue(data);
};

export const handleComebackFromPN = () => {
  window.bridgeRegisterHandler('didOpenCSChatViaPN', function () {
    console.log('======== didOpenCSChatViaPN ========');
    initStore.UPDATE_IS_FROM_PN(true);
    dispatchTrack({ operation: TRACKING_OPERATION.VIEW, data: { from_pn: true }});
  });
};

export const addBackToChatbotTip = async () => {
  const { enable: noRealChatbot } = applyChatbotConfig('noRealChatbot', { initStore }) as { enable: boolean };

  const { isPremiumLiveChat } = initStore;
  // MX CO CL preminum
  if (noRealChatbot || isPremiumLiveChat) {
    addDialogue({
      dialogueId: '',
      dialogueType: '',
      from: DIALOGUE_FROM.BOT,
      type: DIALOGUE_TYPE.General,
      data: {
        msgContent: getTrans(TRANSIFY_KEY.AGENT_QUEUE_CANCEL_THANKS_INAGENT),
        options: agentStore.isOfflineWebformSubmitted
          ? [
            {
              button_type: 'btn_live',
              text_key: TRANSIFY_KEY.BTN_LIVE,
            },
          ]
          : [
            {
              button_type: 'btn_live',
              text_key: TRANSIFY_KEY.BTN_LIVE,
            },
            {
              button_type: 'btn_redirection',
              text_key: Copywriting.AGENT_QUEUE_EMAIL_BTN,
              uri_key: await getOfflineFormUrlWithParams(),
            },
          ],
      },
    });
  } else {
    addDialogue({
      dialogueId: '',
      dialogueType: '',
      from: DIALOGUE_FROM.BOT,
      type: DIALOGUE_TYPE.Msg,
      data: { content: getTrans(TRANSIFY_KEY.AGENT_QUEUE_CANCEL_THANKS) },
    });

    uploadMessageToSave({
      dialogueId: '',
      messages: [
        {
          message_text: getTrans(TRANSIFY_KEY.AGENT_QUEUE_CANCEL_THANKS),
          is_sent_by_user: false,
        },
      ],
    });
  }
};

export const checkIsAutoQueue = async (liveAgentInfo: { letUserChoose?: boolean; queueType?: QueueType }) => {
  const channelType = await agentStore.chat.getChannelType();
  const { letUserChoose, queueType } = liveAgentInfo;
  return letUserChoose === false && channelType === ChannelType.inhouse && queueType === QueueType.inhouse;
};

export const transformFrom = () => {
  const { isPremium, from, pageBeforeHc } = initStore;
  // 根据实验 如果是实验组
  // url 有 page_before_hc 字段传递了上一个页面的 entry point 则使用用这个 entry point 进线
  // 如果 是对照组 则逻辑照旧
  const entryPoint = getOrderSpecificLandingPage() ? (pageBeforeHc || from) : from;

  const shouldTransformFrom = ['sellingPage', 'shippingPage', 'RRDetailsPage', 'RRShippingPage', 'OrderDetailPage'];
  return shouldTransformFrom.includes(entryPoint) && isPremium ? `${entryPoint}Premium` : entryPoint;
};

export function getLiveAgentRecommenderInfo({
  presetUserType,
  presetEnquiryType,
}: {
  presetUserType?: number | string;
  presetEnquiryType?: number | string;
}) {
  const { userType: userTypeInStore, enquiryType: enquiryTypeInStore } = agentStore;
  const hasPresetQueueInfo = !!(presetUserType && presetEnquiryType);
  const hasTriggeredLiveAgent = !!(userTypeInStore && enquiryTypeInStore);
  const userType = presetUserType || userTypeInStore;
  const enquiryType = presetEnquiryType || enquiryTypeInStore;
  const noQueueInfo = !(userType && enquiryType);
  const triggerLiveAgentRecommender = ['disable_display', 'disable_display_with_new_flow'].includes((userStore.newABTestingConfigs as Record<string, any>).display_logic) ? false : (noQueueInfo || (!hasPresetQueueInfo && hasTriggeredLiveAgent));

  return {
    userType,
    enquiryType,
    triggerLiveAgentRecommender,
  };
}
